
import { StatCardData } from '../types';
import { STAT_CARDS_STORAGE_KEY } from '../constants';
import { logStatsData } from './logger';

export const saveCardsToStorage = (cards: StatCardData[]): void => {
  try {
    localStorage.setItem(STAT_CARDS_STORAGE_KEY, JSON.stringify(cards));
    logStatsData('Saved stat cards order to localStorage');
  } catch (error) {
    console.error('Error saving stat cards to localStorage:', error);
  }
};

export const loadCardsFromStorage = (): StatCardData[] | null => {
  try {
    const savedCards = localStorage.getItem(STAT_CARDS_STORAGE_KEY);
    if (!savedCards) return null;
    
    const parsedCards = JSON.parse(savedCards) as StatCardData[];
    logStatsData(`Loaded saved stat cards from localStorage: ${parsedCards.length}`);
    
    // Validate that all cards have the required fields
    const isValid = parsedCards.every(card => 
      typeof card === 'object' && 
      card !== null && 
      typeof card.id === 'string' && 
      card.id.startsWith('stat-')
    );
    
    if (!isValid) {
      throw new Error('Invalid card data format');
    }
    
    return parsedCards;
  } catch (parseError) {
    console.error('Error parsing saved stat cards:', parseError);
    localStorage.removeItem(STAT_CARDS_STORAGE_KEY); // Clear invalid data
    return null;
  }
};
